import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles(
    {
      root: {
        flexGrow: 1
      },
      filterSection: {
        padding: theme.spacing(1, 2, 1, 0),
        flexGrow: 1,
        '& .filterHeading': {
          alignSelf: "flex-start",
          '& .headingContainer': {
            cursor: "pointer",
            '& .heading': {
              fontSize: 16,
              fontWeight: 600,
              color: theme.palette.primary.main,
            },
            '& .logo': {
              transform: "rotate(0deg)",
              transition: "transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
              '&.open': {
                transform: "rotate(180deg)",
              }
            }
          }
        },
        '& .filtersContent': {
          '& .buttons': {
            marginLeft: "auto",
            alignSelf: "center"
          },
          '& .search': {
            margin: 8,
          }
        }
      },
      exceptionsFilterSection: {
        padding: theme.spacing(1, 2, 1, 1),
        flexGrow: 1,
        '& .filterHeading': {
          alignSelf: "flex-start",
          '& .headingContainer': {
            cursor: "pointer",
            '& .heading': {
              fontSize: 16,
              fontWeight: 600,
              color: theme.palette.primary.main,
            },
            '& .logo': {
              transform: "rotate(0deg)",
              transition: "transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
              '&.open': {
                transform: "rotate(180deg)",
              }
            }
          }
        },
        '& .filtersContent': {
          '& .buttons': {
            marginLeft: "auto",
            alignSelf: "center"
          }
        }
      },
      heading: {
        color: theme.palette.primary.main
      },
      button: {
        margin: theme.spacing(0.5),
        '&.reset-btn': {
          marginRight: theme.spacing(0)
        }
      },
      tableSection: {
        width: '100%',
      }
    }),
);